import { MapUtils } from '../../../utility/map-utils.js';
import { isSameData } from '../../dto/data-model-utils.js';
import { DataModel, SerializationContext, SerializedData, DataModelBuilder } from '../../dto/data-model.js';
import { PhotoReference } from '../file-reference/photo-reference.js';


export class PrintedCardCover extends DataModel {
  static readonly TYPE_ID: string = '3b51b5e3f6634192879add24262ec587';

  constructor(
    public readonly front: PhotoReference | null,
    public readonly back: PhotoReference | null,
  ) {
    super();
  }

  get $typeId(): string {
    return PrintedCardCover.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PrintedCardCover {
    return new PrintedCardCover(
        context.fromDataOrNull<PhotoReference>(MapUtils.getRaw(map, 'front') as SerializedData),
        context.fromDataOrNull<PhotoReference>(MapUtils.getRaw(map, 'back') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'front': context.toDataOrNull(this.front),
      'back': context.toDataOrNull(this.back),
    };
  }

  clone(): this {
    return new PrintedCardCover(
        this.front?.clone() ?? null,
        this.back?.clone() ?? null,
    ) as this;
  }

  isSame(other: PrintedCardCover): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.front, this.front) &&
      isSameData(other.back, this.back);
  }
}

export class PrintedCardCoverBuilder extends DataModelBuilder<PrintedCardCover> {
  build(context: SerializationContext, map: SerializedData): PrintedCardCover {
    return PrintedCardCover.fromMap(context, map);
  }
}
